<script>
export default
{
    name: 'layout-main',
}
</script>

<template>
    <div>
        <mv-sidebar></mv-sidebar>
        <main id="content">
            <transition name="slide-vertical" mode="out-in">
                <router-view></router-view>
            </transition>
        </main>
    </div>
</template>

<style lang="scss">
main {
    transition: all .5s ease;
    margin-top: 4em;
    padding: 1em;
}

@media (min-width:768px) {

    main {
        margin-left: 4em;
    }

}

@media (min-width:1200px) {

    main {
        margin-left: 225px;
    }

}
</style>


// WEBPACK FOOTER //
// src/layouts/Main.vue